import React from "react";
import Typewriter from "typewriter-effect";
export default function StepDesc(props) {
  return (
    <div
      style={{
        width: "100%",
        margin: "20px auto 30px",
        textAlign: "justify",
        fontSize: "1.2em",
        lineHeight: "1.9",
        border: "1px dotted rgb(72, 72, 72)",
        padding: "10px 30px",
        borderRadius: "20px",
        transition:"height 0.8s ease-in"
      }}
    >
      <p>
        <Typewriter
          options={{
            loop: false,
            delay: 10,
            // deleteSpeed: 50,
          }}
          onInit={(typewriter) => {
            typewriter
              .typeString(props.children)
              .callFunction(() => {
                // console.log("String typed out!");
              })
              .pauseFor(150)

              .start();
          }}
        />

        {/* {props.children} */}
      </p>
    </div>
  );
}
